import { render, staticRenderFns } from "./SubmitalShow.vue?vue&type=template&id=b850245a&scoped=true&"
import script from "./SubmitalShow.vue?vue&type=script&lang=js&"
export * from "./SubmitalShow.vue?vue&type=script&lang=js&"
import style0 from "./SubmitalShow.vue?vue&type=style&index=0&id=b850245a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b850245a",
  null
  
)

export default component.exports